import { Box, Fade, Modal, Stack, Typography, Divider, Button } from '@mui/material';
import { PropsWithChildren } from 'react';
import i18n from '../../../../../libs/language';
import { silobagDataDetailService } from '@old/services/domain/base/silobag/base/silobag-data-detail';
import { useGlobalStore } from '@old/global-store/use-store';

type SummarySilobagDetail = Awaited<ReturnType<typeof silobagDataDetailService>>['summary'];
type SilobagInsuranceData = SummarySilobagDetail['silobags_history'][0]; // falta completar el tipado con la nueva respuesta del back

enum LinkTypeID {
  RUS = 1,
  LA_SEGUNDA = 2,
  GALICIA = 3,
  FED_PATRONAL = 4,
  SWISS_RE = 5,
}

type InsuranceData = {
  open: boolean;
  onClose: () => void;
  entry: SilobagInsuranceData;
};

export function InsuranceModal(props: InsuranceData) {
  const { preferedLanguageId } = useGlobalStore();

  const { open, onClose } = props;
  if (!open) return null;

  const linkTypeID = props.entry.external_links.link_type_id;
  const Component =
    linkTypeID === LinkTypeID.RUS ? (
      <RusModal
        logoURL={props.entry.external_links.data.logo_url}
        company={{
          name: props.entry.external_links.data.silobag_info[0].company_name,
          taxId: props.entry.external_links.data.silobag_info[0].company_tax_id,
        }}
        silobag={{
          id: props.entry.silobag_id,
          species:
            props.entry.external_links.data.silobag_info[0].silobag_species_types[
              preferedLanguageId === 'es' ? 1 : 0
            ].name,
        }}
        duration={props.entry.external_links.data.duration}
        sumAssured={props.entry.external_links.data.sum_assured}
        description={props.entry.external_links.data.description}
        onClose={onClose}
      />
    ) : linkTypeID === LinkTypeID.LA_SEGUNDA ? (
      <GenericModal
        type="lasegunda"
        logoURL={props.entry.external_links.data.logo_url}
        silobags={props.entry.external_links.data.silobag_info.map((sb) => ({
          id: sb.id,
          species: sb.silobag_species_types[preferedLanguageId === 'es' ? 1 : 0].name,
          company_name: sb.company_name,
          company_taxid: sb.company_tax_id,
        }))}
        duration={props.entry.external_links.data.duration}
        sumAssured={{
          amount: props.entry.external_links.data.sum_assured,
          currency: props.entry.external_links.data.currency,
        }}
        onClose={onClose}
      />
    ) : linkTypeID === LinkTypeID.GALICIA ? (
      <GenericModal
        type="galicia"
        logoURL={props.entry.external_links.data.logo_url}
        silobags={props.entry.external_links.data.silobag_info.map((sb) => ({
          id: sb.id,
          species: sb.silobag_species_types[preferedLanguageId === 'es' ? 1 : 0].name,
          company_name: sb.company_name,
          company_taxid: sb.company_tax_id,
          province: sb.countryL1_name,
        }))}
        duration={props.entry.external_links.data.duration}
        sumAssured={{
          amount: props.entry.external_links.data.sum_assured,
          currency: props.entry.external_links.data.currency,
        }}
        onClose={onClose}
      />
    ) : linkTypeID === LinkTypeID.FED_PATRONAL ? (
      <GenericModal
        type="fedpatronal"
        logoURL={props.entry.external_links.data.logo_url}
        silobags={props.entry.external_links.data.silobag_info.map((sb) => ({
          id: sb.id,
          species: sb.silobag_species_types[preferedLanguageId === 'es' ? 1 : 0].name,
          company_name: sb.company_name,
          company_taxid: sb.company_tax_id,
        }))}
        duration={props.entry.external_links.data.duration}
        sumAssured={{
          amount: props.entry.external_links.data.sum_assured,
          currency: props.entry.external_links.data.currency,
        }}
        onClose={onClose}
      />
    ) : linkTypeID === LinkTypeID.SWISS_RE ? (
      <GenericModal
        type="swissre"
        logoURL={props.entry.external_links.data.logo_url}
        silobags={props.entry.external_links.data.silobag_info.map((sb) => ({
          id: sb.id,
          species: sb.silobag_species_types_name,
          company_name: sb.company_name,
          company_taxid: sb.company_tax_id,
        }))}
        duration={props.entry.external_links.data.duration}
        sumAssured={{
          amount: props.entry.external_links.data.sum_assured,
          currency: props.entry.external_links.data.currency,
        }}
        onClose={onClose}
      />
    ) : (
      <Box>
        <Typography variant="h6">{i18n.t('app.silobag_insurance.unsupported_insurer')}</Typography>
      </Box>
    );

  return (
    <MyModal open={open} onClose={onClose}>
      {Component}

      {/* <Divider sx={{ borderColor: '#E0E0E0' }} /> */}

      {/* Información adicional */}
      {/* <Box>
        <Typography
          variant="caption"
          sx={{
            color: '#7A7A7A',
            fontSize: '0.66rem',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            mb: 1.5,
            display: 'block',
          }}
        >
          {i18n.t('app.silobag_share.aditional_information')}
        </Typography>

        <Box
          sx={{
            backgroundColor: '#F3F2F7',
            borderRadius: 1.5,
            px: 2,
            py: 1.5,
          }}
        >
          <Stack spacing={1.5}>
            
            <Stack direction="row" spacing={4} justifyContent="space-between" alignItems="center">
              <Typography
                variant="caption"
                sx={{
                  color: '#7A7A7A',
                  fontSize: '0.7rem',
                  fontWeight: 500,
                }}
              >
                {i18n.t('app.user')}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: '#49454F',
                  fontWeight: 500,
                  fontSize: '0.85rem',
                }}
              >
                Juan Pérez
              </Typography>
            </Stack>

            
            <Stack direction="row" spacing={4} justifyContent="space-between" alignItems="center">
              <Typography
                variant="caption"
                sx={{
                  color: '#7A7A7A',
                  fontSize: '0.7rem',
                  fontWeight: 500,
                }}
              >
                Fecha de emisión
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: '#49454F',
                  fontWeight: 500,
                  fontSize: '0.85rem',
                }}
              >
                24/10/2025
              </Typography>
            </Stack>
          </Stack>
        </Box>
      </Box> */}

      {/* Botón cerrar - Siempre visible */}
      <Stack width="100%" direction="row" justifyContent="flex-end" alignItems="center" pt={1}>
        <Button
          variant="outlined"
          style={{
            width: 115,
            borderRadius: 100,
            textTransform: 'none',
            border: 'none',
            color: 'black',
          }}
          onClick={props.onClose}
        >
          {i18n.t('app.close')}
        </Button>
      </Stack>
    </MyModal>
  );
}

type LaSegundaSilobag = { id: string; species: string; company_name: string; company_taxid: string };
type GaliciaSilobag = LaSegundaSilobag & { province: string };
type SwissReSilobag = { id: string; species: string; company_name: string; company_taxid?: string }; // TODO: falta agregar copmany_taxid desde el back

type LaSegundaData = {
  type: 'lasegunda';
  silobags: LaSegundaSilobag[];
};
type GaliciaData = {
  type: 'galicia';
  silobags: GaliciaSilobag[];
};
type FedPatronalData = {
  type: 'fedpatronal';
  silobags: LaSegundaSilobag[];
};
type SwissReData = {
  type: 'swissre';
  silobags: SwissReSilobag[];
};

type GenericData = (LaSegundaData | GaliciaData | FedPatronalData | SwissReData) & {
  logoURL: string;
  duration: number | null;
  sumAssured: {
    amount: number;
    currency: string;
  };
  onClose: () => void;
};
function GenericModal(props: GenericData) {
  // Calcular cantidad de compañías únicas
  const uniqueCompanies = new Set(props.silobags.map((sb) => sb.company_taxid)).size;

  return (
    <Stack width="100%" spacing={2.5}>
      {/* Header */}
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack spacing={1}>
          <Typography
            variant="h6"
            component="h2"
            sx={{
              fontWeight: 600,
              color: '#49454F',
              fontSize: '1.25rem',
            }}
          >
            {i18n.t('app.detail')}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: '#7A7A7A',
              fontSize: '0.875rem',
            }}
          ></Typography>
        </Stack>

        {/* Logo de la compañía */}
        <img
          src={props.logoURL}
          alt="Logo aseguradora"
          style={{
            maxWidth: '200px',
            maxHeight: '80px',
            objectFit: 'contain',
          }}
        />
      </Stack>

      <Divider flexItem sx={{ borderColor: '#E0E0E0' }} style={{ margin: 0 }}>
        <Typography
          variant="caption"
          sx={{
            color: '#7A7A7A',
            fontSize: '0.66rem',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            display: 'block',
          }}
        >
          {i18n.t('app.silobag_insurance.history_modal.title')}
        </Typography>
      </Divider>

      {/* Contenido scrolleable */}
      <Box
        sx={{
          maxHeight: 'calc(95vh - 280px)',
          overflowY: 'auto',
          overflowX: 'hidden',
          pr: 1,
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: '#f1f1f1',
            borderRadius: '10px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#888',
            borderRadius: '10px',
            '&:hover': {
              backgroundColor: '#555',
            },
          },
        }}
        style={{ margin: 0 }}
      >
        <Stack spacing={2.5}>
          {/* Información principal */}
          <Stack spacing={2.5}>
            {/* Primera fila: Suma asegurada y Duración */}
            <Stack spacing={3} direction="row" justifyContent="space-between" alignItems="flex-start">
              {/* Duración */}
              <Box>
                <Typography
                  variant="caption"
                  sx={{
                    color: '#7A7A7A',
                    fontSize: '0.66rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                  }}
                >
                  {i18n.t('app.silobag_insurance.history_modal.duration')}
                </Typography>
                {props.duration ? (
                  <Typography
                    variant="body1"
                    sx={{
                      color: '#49454F',
                      fontWeight: 600,
                      fontSize: '1.25rem',
                      mt: 0.5,
                    }}
                  >
                    {props.duration}
                  </Typography>
                ) : (
                  <Box>
                    <Typography
                      variant="caption"
                      sx={{
                        color: '#7A7A7A',
                        fontSize: '0.66rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                      }}
                    >
                      —
                    </Typography>
                  </Box>
                )}
              </Box>

              {/* Suma asegurada */}
              <Box alignSelf="flex-end">
                <Typography
                  variant="caption"
                  sx={{
                    color: '#7A7A7A',
                    fontSize: '0.66rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                  }}
                >
                  {i18n.t('app.silobag_insurance.history_modal.sum_assured')}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: '#49454F',
                    fontWeight: 600,
                    fontSize: '1.25rem',
                    mt: 0.5,
                  }}
                >
                  {`${
                    props.sumAssured.currency === 'Pesos'
                      ? 'ARS'
                      : props.sumAssured.currency === 'Dolares'
                      ? 'USD'
                      : props.sumAssured.currency
                  } ${props.sumAssured.amount.toLocaleString('es-AR')}`}
                </Typography>
              </Box>
            </Stack>

            {/* Segunda fila: Contadores */}
            <Box
              sx={{
                backgroundColor: '#F3F2F7',
                borderRadius: 1.5,
                px: 2,
                py: 1.5,
              }}
            >
              <Stack direction="row" spacing={4} justifyContent="space-around">
                {/* Cantidad de silobolsas */}
                <Stack alignItems="center" flex={1}>
                  <Typography
                    variant="caption"
                    sx={{
                      color: '#7A7A7A',
                      fontSize: '0.7rem',
                      fontWeight: 500,
                      textTransform: 'uppercase',
                    }}
                  >
                    {i18n.t('app.silobag_insurance.history_modal.silobags_assured')}
                  </Typography>
                  <Typography
                    variant="h5"
                    sx={{
                      color: '#6BAA00',
                      fontWeight: 700,
                      fontSize: '1.8rem',
                      mt: 0.5,
                    }}
                  >
                    {props.silobags.length}
                  </Typography>
                </Stack>

                <Divider orientation="vertical" flexItem sx={{ borderColor: '#D0D0D0' }} />

                {/* Cantidad de compañías */}
                <Stack alignItems="center" flex={1}>
                  <Typography
                    variant="caption"
                    sx={{
                      color: '#7A7A7A',
                      fontSize: '0.7rem',
                      fontWeight: 500,
                      textTransform: 'uppercase',
                    }}
                  >
                    {i18n.t('app.companies')}
                  </Typography>
                  <Typography
                    variant="h5"
                    sx={{
                      color: '#22A7F0',
                      fontWeight: 700,
                      fontSize: '1.8rem',
                      mt: 0.5,
                    }}
                  >
                    {uniqueCompanies}
                  </Typography>
                </Stack>
              </Stack>
            </Box>
          </Stack>

          <Divider flexItem sx={{ borderColor: '#E0E0E0' }} style={{ margin: '14px 0' }}>
            <Typography
              variant="caption"
              sx={{
                color: '#7A7A7A',
                fontSize: '0.66rem',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                display: 'block',
              }}
            >
              {i18n.t('app.silobag_insurance.history_modal.silobags_assured')}
            </Typography>
          </Divider>

          <Box style={{ margin: 0 }}>
            {/* Lista de Silobolsas - PROTAGONISTA */}
            <Stack spacing={1.5}>
              {props.silobags.map((silobag) => (
                <Box
                  key={silobag.id}
                  sx={{
                    backgroundColor: 'rgba(107, 170, 0, 0.08)',
                    borderRadius: 2,
                    border: '2px solid #6BAA00',
                    px: 2.5,
                    py: 2,
                  }}
                >
                  <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
                    {/* ID del Silobolsa */}
                    <Stack spacing={0.3} flex={1}>
                      <Typography
                        variant="caption"
                        sx={{
                          color: '#568900',
                          fontSize: '0.65rem',
                          fontWeight: 600,
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                        }}
                      >
                        {i18n.t('app.silobag_id')}
                      </Typography>
                      <Typography
                        variant="h6"
                        sx={{
                          color: '#6BAA00',
                          fontWeight: 700,
                          fontFamily: 'monospace',
                          fontSize: '1.1rem',
                          letterSpacing: '0.3px',
                        }}
                      >
                        {silobag.id}
                      </Typography>
                    </Stack>

                    {/* Especie */}
                    <Stack spacing={0.3} flex={0.6} alignItems="center">
                      <Typography
                        variant="caption"
                        sx={{
                          color: '#568900',
                          fontSize: '0.65rem',
                          fontWeight: 600,
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                        }}
                      >
                        {i18n.t('app.species')}
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          color: '#6BAA00',
                          fontWeight: 600,
                          fontSize: '0.95rem',
                        }}
                      >
                        {silobag.species}
                      </Typography>
                    </Stack>

                    {/* Información de la compañía */}
                    <Stack spacing={0.3} flex={1.5} alignItems="flex-end">
                      <Typography
                        variant="caption"
                        sx={{
                          color: '#568900',
                          fontSize: '0.65rem',
                          fontWeight: 600,
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                        }}
                      >
                        {i18n.t('app.company')}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#49454F',
                          fontWeight: 500,
                          fontSize: '0.85rem',
                          textAlign: 'right',
                        }}
                      >
                        {silobag.company_name}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#49454F',
                          fontWeight: 500,
                          fontSize: '0.8rem',
                          fontFamily: 'monospace',
                        }}
                      >
                        {i18n.t('app.cuit')}:{' '}
                        {silobag.company_taxid
                          ? silobag.company_taxid.slice(0, 2) +
                            '-' +
                            silobag.company_taxid.slice(2, -1) +
                            '-' +
                            silobag.company_taxid.slice(-1)
                          : '—'}
                      </Typography>
                      {props.type === 'galicia' && 'province' in silobag ? (
                        <Typography
                          variant="body2"
                          sx={{
                            color: '#49454F',
                            fontWeight: 500,
                            fontSize: '0.8rem',
                            fontFamily: 'monospace',
                          }}
                        >
                          {i18n.t('app.state')}
                          {': '} {silobag.province}
                        </Typography>
                      ) : null}
                      {/* TODO: Galicia - agregar las filas extra de información que requiere Galicia */}
                    </Stack>
                  </Stack>
                </Box>
              ))}
            </Stack>
          </Box>
        </Stack>
      </Box>
    </Stack>
  );
}

type RusData = {
  logoURL: string;
  company: {
    name: string;
    taxId: string;
  };
  silobag: {
    id: string;
    species: string;
  };
  duration: number | null;
  sumAssured: number;
  description: string;
  onClose: () => void;
};
function RusModal(props: RusData) {
  return (
    <Stack width="100%" spacing={2.5}>
      {/* Header */}
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack spacing={1}>
          <Typography
            variant="h6"
            component="h2"
            sx={{
              fontWeight: 600,
              color: '#49454F',
              fontSize: '1.25rem',
            }}
          >
            {i18n.t('app.detail')}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: '#7A7A7A',
              fontSize: '0.875rem',
              mt: 0.5,
            }}
          >
            {i18n.t('app.silobag_insurance.history_modal.title')}
          </Typography>
        </Stack>

        {/* Logo de la compañía */}
        {props.logoURL && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              py: 2,
            }}
          >
            <Box
              component="img"
              src={props.logoURL}
              alt="Logo aseguradora"
              sx={{
                maxWidth: '200px',
                maxHeight: '80px',
                objectFit: 'contain',
              }}
            />
          </Box>
        )}
      </Stack>

      <Divider flexItem sx={{ borderColor: '#E0E0E0' }}>
        <Typography
          variant="caption"
          sx={{
            color: '#7A7A7A',
            fontSize: '0.66rem',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            display: 'block',
          }}
        >
          {i18n.t('app.silobag_insurance.history_modal.silobag_assured')}
        </Typography>
      </Divider>

      {/* Contenido scrolleable */}
      <Box
        sx={{
          maxHeight: 'calc(95vh - 280px)',
          overflowY: 'auto',
          overflowX: 'hidden',
          pr: 1,
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: '#f1f1f1',
            borderRadius: '10px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#888',
            borderRadius: '10px',
            '&:hover': {
              backgroundColor: '#555',
            },
          },
        }}
      >
        <Stack spacing={2.5}>
          <Box>
            {/* Información del Silobolsa - PROTAGONISTA */}
            <Box
              sx={{
                backgroundColor: 'rgba(107, 170, 0, 0.08)',
                borderRadius: 2,
                border: '2px solid #6BAA00',
                px: 3,
                py: 2.5,
              }}
            >
              <Stack direction="row" spacing={2} justifyContent="space-around" alignItems="center">
                {/* ID del Silobolsa */}
                <Stack alignItems="center">
                  <Typography
                    variant="caption"
                    sx={{
                      color: '#568900',
                      fontSize: '0.7rem',
                      fontWeight: 600,
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                    }}
                  >
                    {i18n.t('app.silobag_id')}
                  </Typography>
                  <Typography
                    variant="h5"
                    sx={{
                      color: '#6BAA00',
                      fontWeight: 700,
                      fontFamily: 'monospace',
                      fontSize: '1.5rem',
                      mt: 0.5,
                      letterSpacing: '0.5px',
                    }}
                  >
                    {props.silobag.id}
                  </Typography>
                </Stack>

                {/* Especie */}
                <Stack alignItems="center">
                  <Typography
                    variant="caption"
                    sx={{
                      color: '#568900',
                      fontSize: '0.7rem',
                      fontWeight: 600,
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                    }}
                  >
                    {i18n.t('app.species')}
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{
                      color: '#6BAA00',
                      fontWeight: 600,
                      fontSize: '1.15rem',
                      mt: 0.5,
                    }}
                  >
                    {props.silobag.species}
                  </Typography>
                </Stack>
              </Stack>
            </Box>
          </Box>

          <Divider sx={{ borderColor: '#E0E0E0' }}>
            <Typography
              variant="caption"
              sx={{
                color: '#7A7A7A',
                fontSize: '0.66rem',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                display: 'block',
              }}
            >
              {i18n.t('app.silobag_insurance.history_modal.general_information')}
            </Typography>
          </Divider>

          {/* Información principal */}
          <Stack spacing={4} direction="row" justifyContent="space-between">
            {/* CUIT de la compañía */}
            <Box>
              <Typography
                variant="caption"
                sx={{
                  color: '#7A7A7A',
                  fontSize: '0.66rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                {i18n.t('app.company')}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: '#49454F',
                  fontWeight: 500,
                  fontSize: '1rem',
                  mt: 0.5,
                  fontFamily: 'monospace',
                }}
              >
                {props.company.name}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: '#49454F',
                  fontWeight: 500,
                  fontSize: '1rem',
                  mt: 0.5,
                  fontFamily: 'monospace',
                }}
              >
                {i18n.t('app.cuit')}
                {': '}
                {props.company.taxId}
              </Typography>
            </Box>

            <Stack spacing={2} justifyContent="space-between">
              {/* Suma asegurada */}
              <Box>
                <Typography
                  variant="caption"
                  sx={{
                    color: '#7A7A7A',
                    fontSize: '0.66rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                  }}
                >
                  {i18n.t('app.silobag_insurance.history_modal.sum_assured')}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: '#49454F',
                    fontWeight: 600,
                    fontSize: '1.25rem',
                    mt: 0.5,
                  }}
                >
                  {props.sumAssured.toLocaleString('es-AR')}
                </Typography>
              </Box>
              {/* Duración */}
              {props.duration ? (
                <Box alignSelf="flex-end">
                  <Typography
                    variant="caption"
                    sx={{
                      color: '#7A7A7A',
                      fontSize: '0.66rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                    }}
                  >
                    {i18n.t('app.silobag_insurance.history_modal.duration')}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: '#49454F',
                      fontWeight: 600,
                      fontSize: '1.25rem',
                      mt: 0.5,
                    }}
                  >
                    {props.duration}{' '}
                    {props.duration === 1
                      ? i18n.t('app.silobag_insurance.month')
                      : i18n.t('app.silobag_insurance.months')}
                  </Typography>
                </Box>
              ) : (
                <Box>
                  <Typography
                    variant="caption"
                    sx={{
                      color: '#7A7A7A',
                      fontSize: '0.66rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                    }}
                  >
                    —
                  </Typography>
                </Box>
              )}
            </Stack>
          </Stack>
        </Stack>
      </Box>
    </Stack>
  );
}

type ModalProps = {
  open: boolean;
  onClose: () => void;
};
function MyModal({ open, onClose, children }: PropsWithChildren<ModalProps>) {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: '680px',
    minWidth: '320px',
    overflowX: 'hidden',
    maxHeight: '95vh',
    overflowY: 'auto',
    bgcolor: 'background.paper',
    borderRadius: 4,
    boxShadow: 24,
    px: 4,
    py: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  };

  const handleClose = (_: never, reason: string) => {
    if (reason === 'backdropClick') return;
    onClose();
  };

  return (
    <Modal open={open} keepMounted onClose={handleClose}>
      <Fade in={open} appear={false} timeout={175}>
        <Box sx={style} component={'div'}>
          {children}
        </Box>
      </Fade>
    </Modal>
  );
}
